export const NAMED_ONBOARDING_WIZARD_STEPS = {
    LANGUAGE_SELECTOR_PAGE: 1,
    WELCOME_PAGE: 2,
    CREATE_USER_PAGE: 3,
    CREATE_PAYMENT_PROFILE_PAGE: 4,
    TRANSFER_METHOD_WIZARD: 5,
    ONBOARDING_COMPLETE_PAGE: 6,
}

export const NAMED_TRANSFER_METHOD_WIZARD_STEPS = {
    SELECT: 1,
    DIRECT_DEPOSIT: 2,
    PAYPAL: 3,
    VENMO: 4,
    PREPAID_CARD: 5,
}

export const NAMED_HELP_WIZARD_STEPS = {
    HELP_SELECTOR: 1,
    HELP_FAQ: 2,
    HELP_EMAIL: 3,
    HELP_CONTACT_US: 4,
}
